import {useEffect, useRef, useState} from 'react';

import {FineUploaderBasic} from 'fine-uploader/lib/core';

import {AttachmentsContextType} from 'app/general/uploader/types';

import {useDeleteAttachment} from './api';

import {BaseAttachedImage} from 'sweet-types';

export function useAttachmentsUploader(): AttachmentsContextType {
  const [submittedImages, setSubmittedImages] = useState<number[]>([]);
  const [attachments, setAttachments] = useState<Array<BaseAttachedImage>>([]);
  const uploaderRef = useRef<FineUploaderBasic>(null);
  const [deleteAttachment, {isSuccess}] = useDeleteAttachment();

  function onImageUpload(image: BaseAttachedImage) {
    setAttachments((prev) => [...prev, image]);
  }

  function cancelUploadImage(id: number) {
    setSubmittedImages((prev) => prev.filter((fileId) => fileId !== id));
  }

  useEffect(
    function () {
      if (isSuccess) {
        reset();
      }
    },
    [isSuccess]
  );

  function reset() {
    setAttachments([]);
    setSubmittedImages([]);
  }

  function removeAttachment(imageRef: string) {
    deleteAttachment({
      key: imageRef,
    });
  }

  return {
    submittedImages,
    attachments,
    uploaderRef,
    onImageUpload,
    setSubmittedImages,
    setAttachments,
    cancelUploadImage,
    removeAttachment,
    reset,
  };
}
